import Content from "./components/content";
import ContentInfo from "./components/contentInfo";
import Header from "./components/header";
import style from "./details.module.scss";
function ArticleDetails({
  setOpen,
  Approval,
  selectedArticle,
  setIsApprove = () => {},
  setIsReject = () => {},
  setIsDelete = () => {},
  isHistory,
  tabActive,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="w-full flex flex-column">
        {/* Header */}
        <div
          className={`flex gap-2 align-center w-full justify-between ${style["header-wrapper"]}`}
        >
          <Header
            setIsReject={setIsReject}
            setIsApprove={setIsApprove}
            handleClose={handleClose}
            selectedArticle={selectedArticle}
            isHistory={isHistory}
            Approval={Approval}
            setDlt={setIsDelete}
            tabActive={tabActive}
          />
        </div>
        <div className={style["body-wrapper"]}>
          {/* Left Section : Content */}
          <div className={style["left-section"]}>
            <Content selectedArticle={selectedArticle} />
          </div>
          <div className={style["right-section"]}>
            {/* Right Section (Content Info) : Status, Image caption:,
             Author, Recipients, Source, Created date, Expiry date & time, Activity log  */}
            <ContentInfo selectedArticle={selectedArticle} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ArticleDetails;
